// extracted by mini-css-extract-plugin
export default {"root":"MemoryTabs_root-ZLX","tab":"MemoryTabs_tab-BbJ","active":"MemoryTabs_active-VLD","label":"MemoryTabs_label-fAr","icon":"MemoryTabs_icon-mJA"};